import React from "react";

const DailyJamPage = ({ onBack, onComplete }) => {
  return (
    <div className="h-screen w-full flex flex-col justify-between items-center bg-[#FFE748]">
      <div className="w-full flex justify-start pt-[60px] pr-[10px] pb-[11px] pl-[20px]">
        <button
          onClick={onBack}
          className="bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      </div>

      <div className="text-center mt-4">
        <h1 className=" font-young-serif text-[50px] leading-[55px] font-medium text-[#1E0A1E]">
          Let’s design
          <br />
          your perfect
          <br />
          daily jam
        </h1>
      </div>

      <div className="flex items-center justify-center mt-2">
        <img
          src="/images/target.png"
          alt="Target"
          className="w-96 h-96 md:w-80 md:h-80 lg:w-96 lg:h-96 object-contain"
        />
      </div>

      <div className="flex justify-center mb-8">
        <button onClick={onComplete} className="font-space-grotesk bg-black text-[#EEEEEE] text-md font-medium px-5 py-2.5 rounded-full hover:bg-gray-800 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
          Continue
        </button>
      </div>
    </div>
  );
};

export default DailyJamPage;
